import Link from 'next/link';
import { memo } from 'react';
import { Button } from '@music-vine/cadence/ui';
import type { AssetType } from '@/features/GlobalSearch/types/index';
interface SearchButtonProps {
  assetType: AssetType | 'general';
  children?: React.ReactNode;
  closePopup: () => void;
  href: string;
  id: string | number;
  name: string;
  onNameClick: (content: string | undefined, endSlug: string | undefined, assetType: AssetType | 'general') => void;
  testId?: string;
}
export const SearchButton = memo(({
  id,
  name,
  href,
  closePopup,
  onNameClick,
  assetType,
  testId,
  children
}: SearchButtonProps) => <Button asChild borderRadius="full" className="h-[22px] bg-gray-100 px-2 font-normal text-black lowercase transition-all duration-300 hover:bg-gray-200! 2xl:h-6 2xl:px-2.5 dark:bg-gray-800 dark:text-white hover:dark:bg-gray-700!" fontSize={{
  default: 'xs',
  '2xl': 'sm'
}} key={id} onClick={() => {
  closePopup();
  onNameClick(name, href, assetType);
}}>
      <Link data-testid={testId} href={href}>
        {children ?? name}
      </Link>
    </Button>);
SearchButton.displayName = 'SearchButton';